import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("C:/GitHub/builder-cms-mfe/layouts/default.vue").then(m => m.default || m))
}